import type { ReactNode } from "react";
import { Box, Column, Row, Text } from "@hightouch/htui";

type ChartWithAxisLabelsProps = {
  xAxisLabel?: string;
  yAxisLabel?: string;
  children: ReactNode;
};

/**
 * Wraps a chart with optional axis labels: a rotated label along the left
 * edge for the y axis and a centered label underneath for the x axis. Each
 * label names its literal axis regardless of chart orientation.
 */
export const ChartWithAxisLabels = ({
  xAxisLabel,
  yAxisLabel,
  children,
}: ChartWithAxisLabelsProps) => {
  if (!xAxisLabel && !yAxisLabel) {
    return <>{children}</>;
  }

  return (
    <Column gap={2} width="100%">
      <Row gap={2} width="100%" alignItems="stretch">
        {yAxisLabel && (
          <Row alignItems="center" flexShrink={0}>
            <Box
              sx={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
            >
              <Text size="sm" color="text.secondary">
                {yAxisLabel}
              </Text>
            </Box>
          </Row>
        )}
        <Box flex={1} minWidth={0}>
          {children}
        </Box>
      </Row>
      {xAxisLabel && (
        <Row justifyContent="center">
          <Text size="sm" color="text.secondary">
            {xAxisLabel}
          </Text>
        </Row>
      )}
    </Column>
  );
};
